package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Cocos Islands Flag (20x15dp)
 *
 * - ISO Alpha-2: CC
 * - ISO Alpha-3: CCK
 * - ISO Numeric: 166
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.CocosIslands: ImageVector by lazy {
    ImageVector.Builder(
        name = "Cocos Islands:CC:CCK:166:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15f, 4.375f)
                lineTo(14.375f, 4.833f)
                lineTo(14.459f, 4.063f)
                lineTo(13.75f, 3.75f)
                lineTo(14.459f, 3.438f)
                lineTo(14.375f, 2.667f)
                lineTo(15f, 3.125f)
                lineTo(15.625f, 2.667f)
                lineTo(15.541f, 3.438f)
                lineTo(16.25f, 3.75f)
                lineTo(15.541f, 4.063f)
                lineTo(15.625f, 4.833f)
                lineTo(15f, 4.375f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.352f, 8.549f)
                lineTo(13.727f, 9.007f)
                lineTo(13.811f, 8.237f)
                lineTo(13.102f, 7.924f)
                lineTo(13.811f, 7.612f)
                lineTo(13.727f, 6.842f)
                lineTo(14.352f, 7.299f)
                lineTo(14.977f, 6.842f)
                lineTo(14.893f, 7.612f)
                lineTo(15.602f, 7.924f)
                lineTo(14.893f, 8.237f)
                lineTo(14.977f, 9.007f)
                lineTo(14.352f, 8.549f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.25f, 11.875f)
                lineTo(15.625f, 12.333f)
                lineTo(15.709f, 11.563f)
                lineTo(15f, 11.25f)
                lineTo(15.709f, 10.938f)
                lineTo(15.625f, 10.167f)
                lineTo(16.25f, 10.625f)
                lineTo(16.875f, 10.167f)
                lineTo(16.791f, 10.938f)
                lineTo(17.5f, 11.25f)
                lineTo(16.791f, 11.563f)
                lineTo(16.875f, 12.333f)
                lineTo(16.25f, 11.875f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.875f, 5.938f)
                lineTo(16.563f, 6.166f)
                lineTo(16.604f, 5.781f)
                lineTo(16.25f, 5.625f)
                lineTo(16.604f, 5.469f)
                lineTo(16.563f, 5.084f)
                lineTo(16.875f, 5.313f)
                lineTo(17.188f, 5.084f)
                lineTo(17.146f, 5.469f)
                lineTo(17.5f, 5.625f)
                lineTo(17.146f, 5.781f)
                lineTo(17.188f, 6.166f)
                lineTo(16.875f, 5.938f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.375f, 8.75f)
                curveTo(6.101f, 8.75f, 7.5f, 7.351f, 7.5f, 5.625f)
                curveTo(7.5f, 3.899f, 6.101f, 2.5f, 4.375f, 2.5f)
                curveTo(2.649f, 2.5f, 1.25f, 3.899f, 1.25f, 5.625f)
                curveTo(1.25f, 7.351f, 2.649f, 8.75f, 4.375f, 8.75f)
                close()
            }
            path(fill = SolidColor(Color(0xFF915E2B))) {
                moveTo(4.056f, 7.492f)
                lineTo(3.832f, 7.334f)
                curveTo(4.328f, 6.684f, 4.197f, 5.776f, 4.056f, 5.179f)
                lineTo(4.968f, 4.964f)
                curveTo(5.178f, 5.853f, 4.713f, 6.632f, 4.056f, 7.492f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.436f, 9.341f)
                curveTo(12.025f, 10.047f, 11.371f, 10.367f, 10.496f, 10.367f)
                curveTo(9.187f, 10.367f, 8.125f, 9.305f, 8.125f, 7.996f)
                curveTo(8.125f, 6.687f, 9.187f, 5.625f, 10.496f, 5.625f)
                curveTo(11.495f, 5.625f, 12.292f, 5.975f, 12.658f, 6.927f)
                curveTo(12.368f, 6.64f, 11.92f, 6.443f, 11.25f, 6.468f)
                curveTo(10.215f, 6.468f, 9.541f, 7.274f, 9.541f, 7.965f)
                curveTo(9.541f, 8.655f, 10.215f, 9.593f, 11.25f, 9.593f)
                curveTo(11.771f, 9.586f, 12.156f, 9.49f, 12.436f, 9.341f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.375f, 5.462f)
                curveTo(5.411f, 5.462f, 6.071f, 5.182f, 6.071f, 4.837f)
                curveTo(6.071f, 4.492f, 5.411f, 4.212f, 4.375f, 4.212f)
                curveTo(3.339f, 4.212f, 2.803f, 4.492f, 2.803f, 4.837f)
                curveTo(2.803f, 5.182f, 3.339f, 5.462f, 4.375f, 5.462f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun CocosIslandsPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.CocosIslands,
            contentDescription = "Cocos Islands Flag"
        )
    }
}
